import React, { useEffect } from 'react';
import { Button, Card, Tabs } from 'antd';
import type { TabsProps } from 'antd';
// import { useSelector } from 'react-redux';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

import Main from '../../components/layout/Main';
import BreadcrumbNav from '../../components/layout/BreadcrumbNav';
import Logout from '../../components/Logout';
import { AppDispatch, CombinedStates } from '../../core/types';

import SchoolIndicatorsData from '../../components/SchoolIndicatorsData';
import ExamsStatistic from '../../components/ExamsStatistic';
import SchoolClassroomStatisticsOverall from '../../components/SchoolClassroomStatisticsOverall';
import AllIndicatorStatistics from '../../components/AllIndicatorStatistics';
import SchoolIndicatorsCalendar from '../../components/SchoolIndicatorsCalendar';
import './educationDepartmentIndicators.scss';

const EducationDepartmentIndicators = () => {
    const dispatch = useDispatch<AppDispatch>();
    const toolbar = [{ label: 'Item 1', link: '/abc', iconName: 'home' }];
    const {
        userData,
    } = useSelector((state:CombinedStates) => state.user);

    const {
        schools,
        isFetching,
    } = useSelector((state:CombinedStates) => state.school);

    const backLink = (
        <Button onClick={() => console.log('Back')}>
            <LeftOutlined /> BACK
        </Button>
    );

    const items: TabsProps['items'] = [
        {
            key: 'indicators',
            label: 'Rodikliai',
            children: (
                <Card>
                    <SchoolIndicatorsData scope="education_department" />
                </Card>
            ),
        },
        {
            key: 'exams',
            label: 'Egzaminų statistika',
            children: <ExamsStatistic />,
        },
        {
            key: 'classrooms',
            label: 'Klasių statistika',
            children: <SchoolClassroomStatisticsOverall />,
        },
        {
            key: 'indicator-statistics',
            label: 'Rodiklių statistika',
            children: <AllIndicatorStatistics />,
        },
        {
            key: 'indicators-calendar',
            label: 'Rodiklių kalendorius',
            children: <SchoolIndicatorsCalendar department="education_department" />,
        },
    ];

    return (
        <Main
            className="education-department"
            title={<div>Švietimo skyriaus rodikliai</div>}
            headerTitle={<div>Švietimo skyriaus rodikliai</div>}
            menuWidth={350}
            menuPlacement="left"
            toolbar={toolbar}
            showFooter={false}
            floatingHeader={false}
            footerContent={<div style={{ lineHeight: '30px', fontSize: '16px', float: 'right' }}>&copy; copyright 2020</div>}
            floatingFooter
            backLink={false}
            breadcrumb={null}>
            <Tabs className="education-department-indicators-tabs" type="card" defaultActiveKey="indicators" items={items} />
        </Main>
    );
};

export default EducationDepartmentIndicators;

EducationDepartmentIndicators.propTypes = {};
